import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/purchaseOrderActions'
import * as api from '../../api/job/jobSitePurchaseOrders'
import * as poApi from '../../api/job/purchaseOrders'

function* getPurchaseOrder(action) {
  try {
    const payload = yield call(api.getPurchaseOrder, action.purchaseOrderId)
    yield put({ type: constants.GET_PURCHASE_ORDER.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PURCHASE_ORDER.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetPurchaseOrder() {
  yield takeLatest(constants.GET_PURCHASE_ORDER.ACTION, getPurchaseOrder)
}

function* getRelatedLeadEstimates(action) {
  try {
    const payload = yield call(poApi.getRelatedLeadEstimates, action.jobId)
    yield put({ type: constants.GET_RELATED_LEAD_ESTIMATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_RELATED_LEAD_ESTIMATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetRelatedLeadEstimates() {
  yield takeLatest(constants.GET_RELATED_LEAD_ESTIMATES.ACTION, getRelatedLeadEstimates)
}

function* getEstimate(action) {
  try {
    const payload = yield call(poApi.getEstimate, action.estimateId)
    yield put({ type: constants.GET_ESTIMATE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ESTIMATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimate() {
  yield takeLatest(constants.GET_ESTIMATE.ACTION, getEstimate)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetPurchaseOrder),
    fork(watchGetRelatedLeadEstimates),
    fork(watchGetEstimate)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/purchaseOrderSaga.js